import {
  Button,
  Icon,
  Menu,
  MenuItem,
  MenuPopup,
  MenuSeparator,
  MenuTrigger,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

type ApiKeyActionsMenuProps = Omittable<{
  onOpenChange?: (open: boolean) => void;
  onEdit: () => void;
  onRevoke: () => void;
}>;

export function ApiKeyActionsMenu({
  onOpenChange,
  onEdit,
  onRevoke,
}: ApiKeyActionsMenuProps) {
  return (
    <Menu onOpenChange={onOpenChange}>
      <MenuTrigger
        render={<Button aria-label="API key actions" size="icon-xs" variant="ghost" />}
      >
        <Icon name="ellipsis" size="md" />
      </MenuTrigger>
      <MenuPopup align="end">
        <MenuItem onClick={onEdit}>
          <Icon name="pen-line" size="md" />
          Edit
        </MenuItem>
        <MenuSeparator />
        <MenuItem onClick={onRevoke}>
          <Icon name="trash" size="md" />
          Revoke...
        </MenuItem>
      </MenuPopup>
    </Menu>
  );
}
